import { render, staticRenderFns } from "./menu-master-screen.vue?vue&type=template&id=134407d0"
import script from "./menu-master-screen.vue?vue&type=script&lang=js"
export * from "./menu-master-screen.vue?vue&type=script&lang=js"
import style0 from "./menu-master-screen.vue?vue&type=style&index=0&id=134407d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports